import { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./Checkout.scss";
import { useCollection } from "../firebase-files/hooks/useCollection";
import { useDocument } from "../firebase-files/hooks/useDocument";
import { useAuthContext } from "../firebase-files/hooks/useAuthContext";
import useOrders from "../firebase-files/hooks/useOrders";
import Skeleton from "react-loading-skeleton";
import CustomSnackbar from "./CustomSnackbar";
import { Alert } from "react-bootstrap";
import ReactPopup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import TextField from "@mui/material/TextField";

const Checkout = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { documents: products } = useCollection("products");
  const { documents: cartProducts } = useCollection("cart");
  const { document: currencyDocument } = useDocument("settings", "currency");
  const { document: paymentMethod } = useDocument("settings", "paymentMethod");
  const { createOrder } = useOrders();

  // State variables
  const [product, setProduct] = useState(null);
  // const [quantity, setQuantity] = useState(1);

  const [quantity, setQuantity] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [tempSelectedAddress, setTempSelectedAddress] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [paymentmethodError, setPaymentMethodError] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [giftData, setGiftData] = useState({
    isGift: false,
    message: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [subscriptionData, setSubscriptionData] = useState({
    isSubscribed: false,
    deliveryInterval: "",
    selectedDeliveryDay: "",
    selectedFrequencyType: "",
    selectedDeliveryDate: "",
  });

  const extractDiscountValue = (discountString) => {
    if (discountString == null) return 0; // handles undefined or null
    const str = String(discountString); // ensure it's always a string
    const match = str.match(/\d+/);
    return match ? Number(match[0]) : 0;
  };

  // Find product by ID
  useEffect(() => {
    if (products && id) {
      const foundProduct = products.find((p) => p.id === id);
      setProduct(foundProduct);

      // Set default variant, color, size if available
      if (foundProduct?.variants?.length > 0) {
        setSelectedVariant(foundProduct.variants[0]);
        if (foundProduct.variants[0].colors?.length > 0) {
          setSelectedColor(foundProduct.variants[0].colors[0]);
        }
        if (foundProduct.variants[0].sizes?.length > 0) {
          setSelectedSize(foundProduct.variants[0].sizes[0]);
        }
      }
    }
  }, [products, id]);

  // Set default address
  useEffect(() => {
    if (user?.addresses?.length > 0) {
      const defaultAddr =
        user.addresses.find((address) => address.isDefault) ||
        user.addresses[0];
      setSelectedAddress(defaultAddr);
      setTempSelectedAddress(defaultAddr);
    }
  }, [user]);

  // Loading state
  useEffect(() => {
    if (products && currencyDocument && user) {
      setIsLoading(false);
    }
  }, [products, currencyDocument, user]);

  // useEffect(() => {
  //   if (cartProducts && user && id) {
  //     const matchedCartDoc = cartProducts.find(
  //       (cartItem) =>
  //         cartItem.productId === id && cartItem.userId === user.phoneNumber
  //     );

  //     if (matchedCartDoc) {

  //       const {
  //         isSubscribed,
  //         deliveryInterval,
  //         selectedDeliveryDay,
  //         selectedFrequencyType,
  //         selectedDeliveryDate,
  //       } = matchedCartDoc;

  //       setSubscriptionData({
  //         isSubscribed,
  //         deliveryInterval,
  //         selectedDeliveryDay,
  //         selectedFrequencyType,
  //         selectedDeliveryDate,
  //       });
  //     } else {
  //       console.log(
  //         "❌ No matching cart document found for this product and user."
  //       );
  //     }
  //   }
  // }, [cartProducts, user, id]);

  useEffect(() => {
  if (cartProducts && user && id) {
    const matchedCartDoc = cartProducts.find(
      (cartItem) =>
        cartItem.productId === id && cartItem.userId === user.phoneNumber
    );

    if (matchedCartDoc) {
      // ✅ FIX: SET QUANTITY FROM CART
      setQuantity(matchedCartDoc.quantity);

      // ✅ EXISTING SUBSCRIPTION DATA
      setSubscriptionData({
        isSubscribed: matchedCartDoc.isSubscribed || false,
        deliveryInterval: matchedCartDoc.deliveryInterval || "",
        selectedDeliveryDay: matchedCartDoc.selectedDeliveryDay || "",
        selectedFrequencyType: matchedCartDoc.selectedFrequencyType || "",
        selectedDeliveryDate: matchedCartDoc.selectedDeliveryDate || "",
      });
    }
  }
}, [cartProducts, user, id]);



  // Address modal handlers
  const handleAddressModal = () => {
    setIsAddressModalOpen(true);
  };

  const handleAddressSelection = (address) => {
    setTempSelectedAddress(address);
  };

  const handleSaveAddress = () => {
    setSelectedAddress(tempSelectedAddress);
    setIsAddressModalOpen(false);
  };

  // Payment method handler
  const handlePaymentMethodChange = (method) => {
    setSelectedPaymentMethod(method);
    setPaymentMethodError(false);
  };

  // Quantity handlers
  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1 && newQuantity <= (product?.stock || 1)) {
      setQuantity(newQuantity);
    }
  };

  // Variant selection handlers
  // const handleVariantChange = (variant) => {
  //   setSelectedVariant(variant);
  //   if (variant.colors?.length > 0) {
  //     setSelectedColor(variant.colors[0]);
  //   }
  //   if (variant.sizes?.length > 0) {
  //     setSelectedSize(variant.sizes[0]);
  //   }
  // };

  // Calculate total price
  // const calculateGSTAmount = (gst, price) => {
  //   if (!gst || typeof gst !== "string") return 0;

  //   const match = gst.match(/[\d.]+/); // e.g., from "6%" or "12.5%"
  //   if (!match) return 0;

  //   const gstValue = parseFloat(match[0]);
  //   const numericPrice = parseFloat(price);

  //   if (isNaN(gstValue) || isNaN(numericPrice)) return 0;

  //   return (numericPrice * gstValue) / 100;
  // };
  const giftWrapCost =
    giftData.isGift && product?.giftWrapPrice
      ? Number(product.giftWrapPrice)
      : 0;

  // const baseTotal = product ? product.price * quantity : 0;

  // const finalOrderTotal = Number(baseTotal + giftWrapCost);
  const pricePerUnit = Number(product?.price || 0);
const discountPercent = Number(
  extractDiscountValue(product?.discount)
);

// total before discount
const grossTotal = pricePerUnit * quantity;

// discount amount
const discountAmount = (grossTotal * discountPercent) / 100;

// final total after discount
const discountedTotal = grossTotal - discountAmount;

// add gift wrap if any
const finalOrderTotal = discountedTotal + giftWrapCost;


  // const calculateTotal = () => {
  //   if (!product) return 0;
  //   const basePrice = Number(product.price);
  //   const discountValue = extractDiscountValue(product.discount);
  //   const priceAfterDiscount = basePrice * (1 - discountValue / 100);
  //   const gstAmount = Number(
  //     calculateGSTAmount(product.gst, priceAfterDiscount)
  //   );
  //   return (priceAfterDiscount + gstAmount) * quantity;
  // };

  // Validate order
  const validateOrder = () => {
    const errors = [];

    if (!product) {
      errors.push("Product not found");
    }

    if (quantity > (product?.stock || 0)) {
      errors.push(`Only ${product?.stock || 0} units available`);
    }

    if (product?.minQuantity && quantity < product.minQuantity) {
      errors.push(`Minimum quantity required is ${product.minQuantity}`);
    }

    if (product?.maxQuantity && quantity > product.maxQuantity) {
      errors.push(`Maximum quantity allowed is ${product.maxQuantity}`);
    }

    return errors;
  };

  // Handle order placement
  const handlePlaceOrder = async () => {
    if (!selectedAddress && product?.isShippingAllow === true) {
      setSnackbar({
        open: true,
        message: "Please select a delivery address",
        severity: "error",
      });
      return;
    }

    setOrderLoading(true);
    try {
      const validationErrors = validateOrder();
      if (validationErrors.length > 0) {
        setSnackbar({
          open: true,
          message: validationErrors.join(". "),
          severity: "error",
        });
        return;
      }

      const orderProduct = {
        id: product.id,
        quantity: quantity,
        price: product.price,
        name: product.name,
        images: product.images || [],
        color: selectedColor || "",
        size: selectedSize || "",
        variantName: selectedVariant?.name || "",
        category: product.category || "",
        // 🎁 Gift fields
        isGift: giftData.isGift,
        giftMessage: giftData.message.trim(),
        giftWrapPrice: giftData.isGift ? Number(product.giftWrapPrice || 0) : 0,
        // ✅ Push subscription fields from cart doc
        isSubscribed: subscriptionData.isSubscribed || false,
        deliveryInterval: subscriptionData.deliveryInterval || "",
        selectedDeliveryDay: subscriptionData.selectedDeliveryDay || "",
        selectedFrequencyType: subscriptionData.selectedFrequencyType || "",
        selectedDeliveryDate: subscriptionData.selectedDeliveryDate || "",
      };

      const newOrder = await createOrder(
        [orderProduct],
        finalOrderTotal.toFixed(2),
        selectedAddress,
        selectedPaymentMethod
      );

      if (newOrder) {
        navigate(`/ordersummary/${newOrder.id}`);
      } else {
        throw new Error("Failed to create order");
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "Failed to place order",
        severity: "error",
      });
    } finally {
      setOrderLoading(false);
    }
  };

  // Handle proceed to payment
  const handleProceedToPayment = () => {
    if (!selectedPaymentMethod) {
      setPaymentMethodError(true);
      return;
    }

    if (!selectedAddress && product?.isShippingAllow === true) {
      setSnackbar({
        open: true,
        message: "Please select a delivery address",
        severity: "error",
      });
      return;
    }

    const orderProduct = {
      id: product.id,
      quantity: quantity,
      price: product.price,
      name: product.name,
      images: product.images || [],
      color: selectedColor || "",
      size: selectedSize || "",
      variantName: selectedVariant?.name || "",
      // category: product.category || ''
    };

    localStorage.setItem(
      "checkoutDetails",
      JSON.stringify({
        orderProducts: [
          {
            ...orderProduct,
            isGift: giftData.isGift,
            giftMessage: giftData.message.trim(),
            giftWrapPrice: giftWrapCost,
          },
        ],
        orderPrice: finalOrderTotal,
        selectedAddress,
      })
    );

    navigate("/onlinepayment");
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Loading state
  if (!user) {
    return (
      <div className="checkout-page-empty">
        <h2>Please log in to continue</h2>
        <Link to="/login">
          <button>Login</button>
        </Link>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ height: "100vh", padding: "10px" }}>
        <Skeleton count={5} height={100} className="mb-4" />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="checkout-page-empty">
        <h2>Product not found</h2>
        <Link to="/products-two">
          <button>Continue Shopping</button>
        </Link>
      </div>
    );
  }

  // ✅ START CODE FOR GIFT MESSAGE
  const MAX_GIFT_MESSAGE_LENGTH = 200;

  const handleGiftToggle = (checked) => {
    setGiftData({
      isGift: checked,
      message: checked ? giftData.message : "",
    });
  };

  const handleGiftMessage = (value) => {
    if (value.length > MAX_GIFT_MESSAGE_LENGTH) return;

    setGiftData((prev) => ({
      ...prev,
      message: value,
    }));
  };

  // ✅ END CODE FOR GIFT MESSAGE
  return (
    <div className="checkout-page">
      {/* Address Modal */}
      {isAddressModalOpen && (
        <div className="address-list-modal-overlay">
          <div className="address-list-modal">
            <div className="address-list-modal-header">
              <h2>
                Select Address ({user.addresses && user.addresses.length})
              </h2>
              <span
                className="material-symbols-outlined"
                onClick={() => setIsAddressModalOpen(false)}
              >
                close
              </span>
            </div>

            <div className="address-list-modal-body">
              {user.addresses && user.addresses.length >= 1 ? (
                user.addresses.map((address, index) => (
                  <div
                    key={index}
                    className={`address-list-modal-body-single-address ${
                      tempSelectedAddress === address ? "selected-address" : ""
                    }`}
                    onClick={() => handleAddressSelection(address)}
                  >
                    <div className="address-list-modal-body-single-address-type">
                      <span className="material-symbols-outlined">
                        {address.type === "home"
                          ? "home"
                          : address.type === "work"
                          ? "work"
                          : "place"}
                      </span>
                      <span>
                        {address.type.charAt(0).toUpperCase() +
                          address.type.slice(1)}
                      </span>
                    </div>

                    <div className="address-list-modal-body-single-address-details">
                      <h4>{address.name}</h4>
                      <p>
                        {address.houseNumber}, {address.streetLineOne},
                        {address.streetLineTwo && `${address.streetLineTwo},`}
                        {address.landmark && `${address.landmark},`}
                        {address.city}, {address.pincode}, {address.state},{" "}
                        {address.country}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <h4>No address found</h4>
              )}
            </div>

            <div className="address-list-modal-footer">
              <button onClick={() => navigate("/address")}>Manage More</button>
              <div>
                <button onClick={() => setIsAddressModalOpen(false)}>
                  Cancel
                </button>
                {user.addresses && user.addresses.length > 1 && (
                  <button onClick={handleSaveAddress}>Save</button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="checkout-info">
        <div className="checkout-details">
          <div className="checkout-header">
            <h2>Checkout</h2>
            <h2>1 Item</h2>
          </div>

          {/* Product Display */}
          <div className="checkout-product">
            <div className="checkout-product-info">
              <div className="checkout-product-image">
                <img
                  src={
                    product?.images && product.images.length > 0
                      ? typeof product.images[0] === "string"
                        ? product.images[0]
                        : product.images[0]?.url
                      : "placeholder-image-url"
                  }
                  alt={product.name || "Product"}
                />
              </div>
              <div className="checkout-product-details">
                <div className="checkout-product-header">
                  <div className="checkout-product-title-section">
                    <h3>{product.name}</h3>
                    {/* Category and Subcategory Chips */}
                    {(product.category || product.subcategory) && (
                      <div className="checkout-product-categories">
                        {/* {product.category && (
                                                    <span className="category-chip">
                                                        <span className="material-symbols-outlined">category</span>
                                                        {product.category}
                                                    </span>
                                                )} */}
                        {product.subcategory && (
                          <span className="subcategory-chip">
                            <span className="material-symbols-outlined">
                              label
                            </span>
                            {product.subcategory}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Quantity Selection */}
                <div className="checkout-quantity">
                  <label>Quantity:</label>
                  <div className="quantity-controls">
                    <button
                      onClick={() => handleQuantityChange(quantity - 1)}
                      disabled={quantity <= 1}
                      className="quantity-btn"
                    >
                      <span className="material-symbols-outlined">remove</span>
                    </button>
                    <span className="quantity-display">{quantity}</span>
                    <button
                      onClick={() => handleQuantityChange(quantity + 1)}
                      disabled={quantity >= (product.stock || 1)}
                      className="quantity-btn"
                    >
                      <span className="material-symbols-outlined">add</span>
                    </button>
                  </div>
                </div>

                {/* ✅ GIFT MESSAGE CHECKBOX PER ITEM */}
                {product.giftAllow && (
                  <div className="cart-gft-messge-parent">
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        checked={giftData.isGift}
                        onChange={(e) => handleGiftToggle(e.target.checked)}
                      />
                      &nbsp;
                      <p>
                        Make it special with gift wrapping 🎁&nbsp;
                        <span>
                          (
                          {product.giftWrapPrice &&
                          Number(product.giftWrapPrice) > 0
                            ? `₹${product.giftWrapPrice} only`
                            : "Free of charge"}
                          )
                        </span>
                      </p>
                    </div>

                    {giftData.isGift && (
                      <TextField
                        fullWidth
                        minRows={2}
                        maxRows={4}
                        label="Gift Message"
                        placeholder="Write your message (max 200 characters)"
                        value={giftData.message}
                        onChange={(e) => handleGiftMessage(e.target.value)}
                        inputProps={{ maxLength: 200 }}
                        helperText={`${giftData.message.length} / 200 characters`}
                        FormHelperTextProps={{
                          style: {
                            textAlign: "right",
                            color:
                              giftData.message.length === 200 ? "red" : "gray",
                          },
                        }}
                      />
                    )}
                  </div>
                )}

                 <div className="checkout-product-pricing">
                  {/* <div className="price-row">
                    <span className="price-label">Unit Price:</span>
                     /* <span className="price-value">
                      {currencyDocument?.symbol}
                       ({
                        Number(product.price) +
                        (Number(product.price) *
                          Number(extractDiscountValue(product.discount))) /
                          100
                      })
  
                        .toFixed(2)
                        .replace(/\.00$/, "")
                        .replace(/\.0$/, "")
                    </span> 
                  </div>   
                   */}
                  
  <div className="price-row">
    <span className="price-label">Unit Price:</span>
    <span className="price-value">
      {currencyDocument?.symbol}
      {pricePerUnit.toFixed(0)}
    </span>
  </div>



                  {Number(product.discount) > 0 && (
                    <div className="price-row">
                      <span className="price-label">
                        Discount ({product.discount}%):
                      </span>
                      {/* <span className="price-value">-{product.discount}</span> */}
                      <span className="price-value">
  -{currencyDocument?.symbol}
  {discountAmount.toFixed(0)}
</span>

                    </div>
                  )}

                  <div className="price-row total-row">
                    <span className="price-label">Total:</span>
                    <span className="price-value total-value">
                      {currencyDocument?.symbol}
                      {(finalOrderTotal)
                        .toFixed(2)
                        .replace(/\.00$/, "")
                        .replace(/\.0$/, "")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Checkout Summary */}
      <div className="checkout-summary-secondary">
        <div className="checkout-summary">
          <h2>Order Summary</h2>

          <div className="checkout-summary-details">
            <div className="checkout-summary-item">
              <h5 className="d-flex align-items-center">
                Subtotal &nbsp;
                <div className="d-flex align-items-center">
                  <ReactPopup
                    trigger={
                      <span
                        style={{
                          display: "inline-flex",
                          cursor: "pointer",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="22px"
                          viewBox="0 -960 960 960"
                          width="22px"
                          fill="grey"
                        >
                          <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                        </svg>
                      </span>
                    }
                    position="bottom"
                    on="hover"
                  >
                    <div
                      style={{
                        color: "black",
                        backgroundColor: "white",
                        borderRadius: "7px",
                        padding: "15px",
                      }}
                    >
                      Total price you see is inclusive of the product price,
                      taxes, and other charges
                    </div>
                  </ReactPopup>
                </div>
              </h5>

              <h5>
                {currencyDocument?.symbol}
                {(product.price * quantity)
                  .toFixed(2)
                  .replace(/\.00$/, "")
                  .replace(/\.0$/, "")}
              </h5>
            </div>
            {giftWrapCost > 0 && (
              <div className="checkout-summary-item">
                <h5>Gift Wrapping</h5>
                <h5>
                  {currencyDocument?.symbol}
                  {giftWrapCost.toFixed(2).replace(/\.00$/, "")}
                </h5>
              </div>
            )}
          </div>
          <div className="checkout-summary-total">
            <h4>Total</h4>
            <h4>
              {currencyDocument?.symbol}
              {finalOrderTotal.toFixed(2).replace(/\.00$/, "")}
            </h4>
          </div>
          <hr />

          {/* Address Section */}
          {!product?.hasOwnProperty("isShippingAllow") ||
          product.isShippingAllow === true ? (
            <div className="checkout-address-details">
              <div className="checkout-address-header">
                <h2>Shipping Address</h2>
                {user.addresses && user.addresses.length >= 1 && (
                  <span
                    className="material-symbols-outlined"
                    onClick={handleAddressModal}
                  >
                    edit
                  </span>
                )}
              </div>

              <div className="checkout-address-list">
                {user.addresses && user.addresses.length >= 1 ? (
                  <div className="checkout-single-address">
                    <div className="checkout-single-address-details">
                      <h4>
                        {selectedAddress?.name}
                        <span>{selectedAddress?.type}</span>
                      </h4>
                      <p>
                        {selectedAddress?.houseNumber},{" "}
                        {selectedAddress?.streetLineOne},
                        {selectedAddress?.streetLineTwo &&
                          `${selectedAddress.streetLineTwo},`}
                        {selectedAddress?.landmark &&
                          `${selectedAddress.landmark},`}
                        {selectedAddress?.city}, {selectedAddress?.pincode},{" "}
                        {selectedAddress?.state}, {selectedAddress?.country}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="add-new-address">
                    <h5>No Addresses Found</h5>
                    <button onClick={() => navigate("/address")}>
                      Add New
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          <hr />

          {/* Payment Method */}
          <div className="checkout-payment-method">
            <h4>Choose a Payment Method</h4>
            <div className="checkout-payment-method-list">
              {paymentMethod.cod && (
                <div
                  className={`checkout-payment-method-single ${
                    selectedPaymentMethod === "cash"
                      ? "selected-payment-method"
                      : ""
                  }`}
                  onClick={() => handlePaymentMethodChange("cash")}
                >
                  <div>
                    <span className="material-symbols-outlined">payments</span>
                    <span>Cash</span>
                  </div>
                </div>
              )}
              {paymentMethod.razorpay && paymentMethod.razorpay.status && (
                <div
                  className={`checkout-payment-method-single ${
                    selectedPaymentMethod === "online"
                      ? "selected-payment-method"
                      : ""
                  }`}
                  onClick={() => handlePaymentMethodChange("online")}
                >
                  <div>
                    <span className="material-symbols-outlined">
                      credit_card
                    </span>
                    <span>Online Payment</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {paymentmethodError && (
            <Alert variant="danger">Please select a payment method</Alert>
          )}

          {/* Place Order Button */}
          {user.addresses && user.addresses.length === 0 ? (
            <button onClick={() => navigate("/address")}>Add Address</button>
          ) : selectedPaymentMethod === "cash" ? (
            <button onClick={handlePlaceOrder} disabled={orderLoading}>
              {orderLoading ? (
                <div className="checkout-loading">
                  <div className="checkout-loading-spinner"></div>
                  <span>Placing Order...</span>
                </div>
              ) : (
                `Place Order for ${currencyDocument?.symbol}${finalOrderTotal
                  .toFixed(2)
                  .replace(/\.00$/, "")
                  .replace(/\.0$/, "")}`
              )}
            </button>
          ) : (
            <button
              className="checkout-online-payment-btn"
              onClick={handleProceedToPayment}
            >
              <span className="material-symbols-outlined">
                assured_workload
              </span>
              Proceed to Payment
            </button>
          )}
        </div>
      </div>

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

export default Checkout;
